<template>
  <div class='projects-widget' @click.stop='openLink'>
    <donut-widget
      :values='values'
      :labels='labels'
      :show-total=true
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import DonutWidget from '@/components/Dashboard/DonutWidget.vue';

export default {
  name: 'OrganizationsProjectsWidget',
  components: {
    DonutWidget,
  },
  props: {
    url: {
      required: false,
    },
  },
  methods: {
    openLink() {
      if (this.url) {
        this.$router.push(this.url);
      }
    },
    reduceData(obj) {
      return Object.fromEntries(
        // eslint-disable-next-line no-unused-vars
        Object.entries(obj).filter(([key, value]) => value !== 0),
      );
    },
  },
  computed: {
    ...mapGetters(['projectStatistics']),
    labels() {
      if (this.projectStatistics?.organizations) {
        return Object.keys(this.reduceData(this.projectStatistics.organizations));
      }
      return [];
    },
    values() {
      const valuesToLabels = [];
      if (this.projectStatistics?.organizations) {
        this.labels.forEach(label => {
          valuesToLabels.push(this.projectStatistics.organizations?.[label]);
        });
      }
      return valuesToLabels;
    },
  },
};
</script>

<style lang='scss' scoped>
.projects-widget {
  &:hover{
    cursor: pointer;
  }
}
</style>
